import React from 'react'
import withFormContext from 'core/components/validatedForm/withFormContext'
import { ValidatedFormProps } from './model'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import MultiDropdown, { MultiDropdownProps } from 'core/elements/dropdown/MultiDropdown'
import Tooltip, { TooltipProps } from 'core/elements/tooltip/Tooltip'

interface Props extends ValidatedFormProps {
  compact?: boolean
  value?: string[]
  hasError?: boolean
  errorMessage?: string
  onChange?: any
  loading?: boolean
  options: any[]
  label?: string
  multiline?: boolean
  fullWidth?: boolean
  tooltip?: string | React.ReactNode
  tooltipProps?: TooltipProps
  disabled?: boolean
}

export default withFormContext<any[], Props>(function(props) {
  const {
    compact,
    onChange,
    value = [],
    hasError,
    errorMessage,
    options = [],
    label,
    loading,
    tooltip = '',
    tooltipProps,
    disabled,
    ...rest
  } = props

  return (
    <>
      <Tooltip message={tooltip} {...tooltipProps}>
        <MultiDropdown
          compact={compact}
          value={value}
          onChange={onChange}
          label={label}
          loading={loading}
          items={options}
          disabled={disabled}
          {...rest}
        />
      </Tooltip>
      {hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  )
})
